<template>
  <v-card
    v-if="loading || (promotions != null && promotions.length > 0)"
    id="promotions"
    flat
    tile
    width="100%"
    color="primary"
    class="px-4 py-4 py-md-8 py-lg-12"
  >
    <!-- Skeleton loader -->
    <section v-if="loading">
      <v-skeleton-loader type="heading" class="px-3 mb-8" />

      <v-row class="promotions ma-0 px-3">
        <v-col
          v-for="item in [1, 2, 3]"
          :key="item"
          cols="10"
          sm="7"
          md="4"
          lg="3"
          class="pl-0 pr-6"
        >
          <v-skeleton-loader type="card" />
        </v-col>
      </v-row>
    </section>

    <!-- Contents if exist after being loadded -->
    <section v-else>
      <h2
        class="promotionHeader primary-font-color text-break text-center mb-4 mb-md-8"
      >
        {{ promotionHeaderTitle }}
      </h2>

      <ItemGroup
        v-if="false"
        :items="promotions"
        itemImgSrc="PictureUrl"
        itemText="Name"
        :lg="true"
        @select="onEventClick"
      />

      <ItemGroup v-if="true" :items="promotions" :lg="true">
        <template v-slot:item="{ item }">
          <v-hover v-slot="{ hover }">
            <v-card
              height="100%"
              width="100%"
              class="item-card"
              :elevation="hover ? 5 : 1"
              @click="onEventClick(item)"
            >
              <!-- Image -->
              <div v-if="item.PictureUrl !== ''">
                <v-img :aspect-ratio="1.618" :src="item.PictureUrl">
                  <v-card
                    class="pa-3 white--text overlay-card"
                    tile
                    flat
                    color="rgba(50, 50, 50 , 0.7)"
                    width="100%"
                  >
                    <v-row no-gutters>
                      <v-col>
                        <!-- Title -->
                        <div
                          class="promotionName font-weight-bold text-truncate mt-4 mt-md-1 mb-5 mb-md-4"
                        >
                          {{ item.Name }}
                        </div>

                        <!-- Subtitle -->
                        <div
                          class="promotionSubtitle word-break-normal"
                          v-html="item.Subtitle"
                        />
                      </v-col>
                    </v-row>
                  </v-card>
                </v-img>
              </div>
              <div v-else>
                <div class="blurBackground" :style="{ backgroundImage: `url(${item.PortraitPictureUrl})`}"></div>
                <div><v-img  :aspect-ratio="1.618" :src="item.PortraitPictureUrl">
                <v-card
                  class="pa-3 white--text overlay-card"
                  tile
                  flat
                  color="rgba(50, 50, 50 , 0.7)"
                  width="100%"
                >
                  <v-row no-gutters>
                    <v-col>
                      <!-- Title -->
                      <div
                        class="promotionName font-weight-bold text-truncate mt-4 mt-md-1 mb-5 mb-md-4"
                      >
                        {{ item.Name }}
                      </div>

                      <!-- Subtitle -->
                      <div
                        class="promotionSubtitle word-break-normal"
                        v-html="item.Subtitle"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-img>
                </div>
              </div>
            </v-card>
          </v-hover>
        </template>
      </ItemGroup>
    </section>
  </v-card>
</template>

<script>
import { addLog } from '@/api/dssRequest';
import uiHelpers from '@/shared/ui_helpers';
import ItemGroup from '@/components/generalComponents/uiComponents/ItemGroup';

export default {
  name: 'Promotions',
  mixins: [uiHelpers],
  components: {
    ItemGroup,
  },
  computed: {
    loading() {
      return this.$store.getters['user/loadingPromotions'];
    },
    promotions() {
      const showPromotionsOnHomepage = [];
      const allPromotions = this.$store.getters['user/promotions'];
      allPromotions.forEach((promotion) => {
        if (promotion.VisibleOnHomepage) {
          showPromotionsOnHomepage.push(promotion);
        }
      });
      return showPromotionsOnHomepage;
    },
    userObject() {
      return this.$store.getters['auth/userObjectId'];
    },
    promotionHeaderTitle() {
      const pgDetails = this.$store.getters['Account/partnerGroupDetails'];
      if (pgDetails == null || pgDetails.PromotionHeaderTitle == null) {
        return '';
      }

      return pgDetails.PromotionHeaderTitle;
    },
    itemWidth() {
      const { breakpoint } = this.$vuetify;

      switch (breakpoint.name) {
        case 'xl':
          return '19vw';
        case 'lg':
          return '25vw';
        case 'md':
          return '35vw';
        case 'sm':
          return '45vw';
        default:
          return '55vw';
      }
    },
  },
  methods: {
    // return the description if the subTitle is empty
    // (because on phone you can't fill the subtitle in, so in many
    // cases the subtitle should be empty)
    getEventDescription(event) {
      return event.Subtitle !== '' ? event.Subtitle : event.Description;
    },
    onEventClick(event) {
      // Add user interaction to log
      addLog(this.userObject, event.EventId, 'Event', 'Home', -1);
      // Go to event details screen
      this.goToPage('EventDetails', { event_id: event.EventId });

      this.$store.commit('setSelectedItem', event);
      console.log(event)
    },
    getReleaseDate(event) {
      const date = new Date(event.ReleaseDateTime * 1000);
      const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', dateOptions);
    },
  },
};
</script>

<style scoped lang="scss">
//@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@700&display=swap');
//@import url('https://fonts.googleapis.com/css2?family=Nunito:ital,wght@1,300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito:ital@1&display=swap');

.promotions {
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
}
.item-card:hover {
  & .overlay-card {
    height: 100%;
  }
  & .item-description {
    height: 12rem;
  }
}
.overlay-card {
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: 10%;
  min-height: 70px;
  transition: height 0.5s;
}
.item-description {
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 4px;
  height: 0rem;
  transition: height 0.5s;
}
.promotionHeader {
  font-size: 22px;
  line-height: 27px;

  @media only screen and (min-width: 961px) {
    font-size: 38px;
    line-height: 48px;
  }
}
.promotionName {
  font-size: 14px;
  line-height: 20px;
  font-family: Nunito;
  font-weight: 800;
  @media only screen and (min-width: 961px) {
    font-size: 28px;
    line-height: 38px;
  }
}
.promotionSubtitle {
  font-size: 14px;
  line-height: 18px;
  font-family: Nunito;
  font-weight: 400;
  font-style: italic;
  letter-spacing: 0.5px;
  @media only screen and (min-width: 961px) {
    font-size: 24px;
    line-height: 27px;
  }
}
.blurBackground {
  background-size: cover;
  filter: blur(14px);
  height: 100%;
  width: 100%;
}
</style>
